import { type ForwardedRef, type RefObject, useImperativeHandle, useRef } from "react";

export function useDOMRef<T extends HTMLElement>(
  ref: RefObject<T | null> | ForwardedRef<T> | null | undefined,
): RefObject<T | null> {
  type U = T | null;

  const domRef = useRef<T>(null);
  useImperativeHandle<U, U>(ref, () => domRef.current);
  return domRef;
}
